import { ChevronDown, ChevronRight, Menu, X } from "lucide-react";
import { useState } from "react";

const activityItems = [
  ["/rescue", "回穩補給金"],
  ["/newbie", "新人七關"],
  ["/invite", "邀友支線"],
  ["/graduate-week", "畢業首週"],
  ["/weekly-pass", "週通行證"],
  ["/weekend-bonus", "週末耀旺"]
];

const menuItems = [
  ["/", "龍來喬大廳"],
  ["/profile", "我的資料"],
  ["/inventory", "會員背包"],
  ["/red-packet", "紅包券"],
  ["/gems", "寶石碎片"],
  ["/level", "會員身份"],
  ["/calculator", "新人試算"]
];

export function MobileDrawer({ onLogout }: { onLogout: () => void }) {
  const [open, setOpen] = useState(false);
  const [activitiesOpen, setActivitiesOpen] = useState(true);

  return (
    <div className="drawer-shell">
      <button className="drawer-trigger" type="button" onClick={() => setOpen(true)} aria-label="開啟選單">
        <Menu size={20} />
        <span>選單</span>
      </button>
      {open ? (
        <div className="drawer-backdrop" onClick={() => setOpen(false)}>
          <aside className="mobile-drawer" onClick={(event) => event.stopPropagation()}>
            <div className="drawer-head">
              <div>
                <span className="hero-kicker">龍來喬活動</span>
                <h2>龍來喬活動</h2>
              </div>
              <button className="modal-x" type="button" onClick={() => setOpen(false)} aria-label="關閉選單">
                <X size={18} />
              </button>
            </div>
            <nav className="drawer-nav">
              {menuItems.slice(0, 2).map(([href, label]) => <a href={href} key={label}>{label}</a>)}
              <button className="drawer-group-toggle" type="button" onClick={() => setActivitiesOpen((value) => !value)}>
                <span>活動任務</span>
                {activitiesOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </button>
              {activitiesOpen ? (
                <div className="drawer-group">
                  {activityItems.map(([href, label]) => <a href={href} key={label}>{label}</a>)}
                </div>
              ) : null}
              {menuItems.slice(2).map(([href, label]) => <a href={href} key={label}>{label}</a>)}
              <button className="secondary drawer-logout" type="button" onClick={onLogout}>切換會員 / 登出</button>
            </nav>
          </aside>
        </div>
      ) : null}
    </div>
  );
}
